import { type } from "arktype";

export const AccountLookupInputSchema = type({
  tenantId: "string >= 1",
  externalId: "string == 12",
  zipCode: "string.digits == 5",
  nameOnAccount: "string > 1",
});

export type AccountLookupInput = typeof AccountLookupInputSchema.infer;

export const AccountLookupOutputSchema = type({
  balance: "number",
  "dueDate?": "Date | null",
  "accountHolder?": "string | null",
  "maskedContractAccount?": "string | null",
  address: type({
    "street1?": "string | null",
    "street2?": "string | null",
    "city?": "string | null",
    "state?": "string | null",
    "zip?": "string | null",
  }),
  "meterNo?": "string | null",
  "cashOnly?": "boolean",
});

export type AccountLookupOutput = typeof AccountLookupOutputSchema.infer;

export const AccountValidateInputSchema = type({
  tenantId: "string >= 1",
  externalId: "string == 12",
});

export type AccountValidateInput = typeof AccountValidateInputSchema.infer;

export const AccountValidateOutputSchema = type({
  valid: "'true'",
});

export type AccountValidateOutput = typeof AccountValidateOutputSchema.infer;

export const InvoiceLookupInputSchema = type({
  tenantId: "string >= 1",
  externalId: "string == 12",
  invoiceNumber: "string >= 1",
});

export type InvoiceLookupInput = typeof InvoiceLookupInputSchema.infer;

export const AddressSearchInputSchema = type({
  tenantId: "string >= 1",
  streetName: "string >= 1 & string <= 60",
  zipCode: "string.digits == 5",
  houseNumber: "string >= 1 & string <= 10",
  "aptNumber?": "string <= 10",
  "city?": "string <= 40",
  "state?": "string <= 3",
});

export type AddressSearchInput = typeof AddressSearchInputSchema.infer;

export const AddressSearchResultSchema = type({
  contractAccount: "string",
  "fullName?": "string | null",
  address: type({
    "houseNumber?": "string | null",
    "street?": "string | null",
    "city?": "string | null",
    "state?": "string | null",
    "zip?": "string | null",
    "aptNumber?": "string | null",
  }),
});

export type AddressSearchResult = typeof AddressSearchResultSchema.infer;

export const AddressSearchOutputSchema = type({
  results: AddressSearchResultSchema.array(),
});

export type AddressSearchOutput = typeof AddressSearchOutputSchema.infer;
